import { render, staticRenderFns } from "./vcSelectPropertySettings.vue?vue&type=template&id=4a63e5df&"
import script from "./vcSelectPropertySettings.vue?vue&type=script&lang=js&"
export * from "./vcSelectPropertySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports